export ThemeHoC from './theme';
export BusHoC from './bus';
export I18nHoc from './i18n';



// WEBPACK FOOTER //
// ./src/components/hoc/index.js